import React, { useState, useEffect, useRef } from "react";
import {
  Icon,
  Box,
  TextField,
  Button,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector, useDispatch } from "react-redux";

import Translate from "../Translate/Translate";

import "./MapTopbar.css";
import { useAuth0 } from "@auth0/auth0-react";
import {
  fetchVillageDetailsSuccess,
  selectOwnershipType,
} from "../../redux/reducers/villageDetails";
import {
  selectLandType,
  setSelectMinMaxOfSize,
} from "../../redux/reducers/selectedVillageDetails";
import { fetchVillageSitesDetailsSuccess } from "../../redux/reducers/villageSitesDetails";
import { fetchLandParcelDetailsSuccess } from "../../redux/reducers/villageLandParcelDetails";

function MapTopbar() {
  const villageList = useSelector((state) => state.distinctVillages);
  const selectAllOptions = process.env.REACT_APP_ALL_SELECT_OPTION;
  const minSize = process.env.REACT_APP_MIN_SIZE;
  const maxSize = process.env.REACT_APP_MAX_SIZE;

  const landType = useSelector(
    (state) => state.selectedVillageDetails.landType
  );
  const selectedLandType = useSelector(
    (state) => state.selectedVillageDetails.selectedType
  );
  const sizeMinMaxVal = useSelector(
    (state) => state.selectedVillageDetails.selectMinMaxOfSize
  );
  const ownershipType = useSelector((state) => state.villageDetails.ownership);
  const selectedOwnership = useSelector(
    (state) => state.villageDetails.selectedOwnership
  );

  const [selectedVillage, setSelectedVillage] = useState(null);
  const [showInputs, setShowInputs] = useState(false);
  const [minValue, setMinValue] = useState(sizeMinMaxVal[0]);
  const [maxValue, setMaxValue] = useState(sizeMinMaxVal[1]);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const user = useSelector((state) => state.user);

  const [isToggled, setIsToggled] = useState(true);

  const dispatch = useDispatch();

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
    console.log(`Toggle button clicked: ${!isToggled ? "ON" : "OFF"}`);
    if (isToggled) {
      dispatch(setSelectMinMaxOfSize([parseInt(minSize), parseInt(maxSize)]));
    }
  };

  const [showFilters, setShowFilters] = useState({
    size: false,
    land_type: false,
    ownership: false,
    villages: false,
  });

  const filteredVillages = villageList.data.filter((village) =>
    village.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const { users, getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();

  const fetchVillageDetails = async (callback, village) => {
    // check for local storage data
    const villageLocalData = localStorage.getItem(village);
    if (villageLocalData) {
      console.log("found village data in local storage");
      callback(JSON.parse(villageLocalData));
    } else {
      console.log("no data found in local storage for village");
    }

    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });
    const url = `${process.env.REACT_APP_API_BASE_URL}/get_village_details?village=${village}`;

    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Set the data in local storage
        //localStorage.setItem(village, JSON.stringify(data));

        if (villageLocalData) {
          return;
        }

        // Process the retrieved data here
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong", error);
      });
  };

  const fetchSiteDetails = async (callback, village) => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });
    const url = `${process.env.REACT_APP_API_BASE_URL}/get_site_details?village=${village}`;

    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Process the retrieved data here
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong", error);
      });
  };

  const fetchLandParcelDetails = async (callback, village) => {
    const accessToken = await getAccessTokenSilently({
      authorizationParams: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      },
    });
    const url = `${process.env.REACT_APP_API_BASE_URL}/get_land_parcel_details?village=${village}`;

    const authToken = accessToken; // Replace with your actual authorization token

    fetch(url, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // Process the retrieved data here
        callback(data);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error("Error: Something went wrong", error);
      });
  };

  const toggleBox = () => {
    setShowInputs((prev) => !prev); // Toggle the visibility
    setError("");
  };

  const handleSubmit = () => {
    if (!minValue || !maxValue) {
      setError("Please enter both Min and Max values.");
      return;
    }

    if (parseInt(minValue) > parseInt(maxValue)) {
      setError("Max value cannot be smaller than Min value.");
      return;
    }

    if (parseInt(minValue) < 0 || parseInt(maxValue) < 0) {
      setError("Enter value greater than zero.");
      return;
    }
    console.log("Min:", minValue, "Max:", maxValue);
    if (isToggled)
      dispatch(setSelectMinMaxOfSize([parseInt(minValue), parseInt(maxValue)]));
    setShowInputs((prev) => !prev);
    setError("");
  };

  // const updateSelectedVillage = (village) => {
  //   setSelectedVillage((prevVillage) => {
  //     console.log("Previous Village:", prevVillage);
  //     console.log("Updated Village:", village);
  //     localStorage.removeItem(prevVillage);

  //     return village;
  //   });
  //   console.log("village2", selectedVillage);
  //   fetchVillageDetails((data) => {
  //     dispatch(fetchVillageDetailsSuccess(data));
  //   }, village);
  //   fetchSiteDetails((data) => {
  //     dispatch(fetchVillageSitesDetailsSuccess(data));
  //   }, village);
  //   fetchLandParcelDetails((data) => {
  //     dispatch(fetchLandParcelDetailsSuccess(data));
  //   }, village);
  // };

  const updateSelectedVillage = (village) => {
    // If already selected, deselect
    const isDeselecting = selectedVillage === village;
    const newSelected = isDeselecting ? null : village;
  
    // Update state first
    setSelectedVillage((prevVillage) => {
      if (prevVillage) {
        localStorage.removeItem(prevVillage);
      }
      return newSelected;
    });
  
    // Don't fetch if we're deselecting
    if (isDeselecting) return;
  
    // Fetch data for newly selected village
    fetchVillageDetails((data) => {
      dispatch(fetchVillageDetailsSuccess(data));
    }, village);
    fetchSiteDetails((data) => {
      dispatch(fetchVillageSitesDetailsSuccess(data));
    }, village);
    fetchLandParcelDetails((data) => {
      dispatch(fetchLandParcelDetailsSuccess(data));
    }, village);
  };
  

  const handleVillageSelection = (village) => {
    console.log("village1", selectedVillage);
    //fetchVillageDetails((data) => { dispatch(fetchVillageDetailsSuccess(data))}, village)
  };

  const handleLandTypeCheckboxClick = (checked, type) => {
    const typeSelectedObj = {};
    typeSelectedObj[type] = !checked;
    console.log("typeSelectedObj[type] ", typeSelectedObj[type], type);

    dispatch(selectLandType(typeSelectedObj));
  };

  const handleOwnershipCheckboxClick = (checked, type) => {
    const typeSelectedObj = {};
    typeSelectedObj[type] = !checked;
    console.log("typeSelectedObj[type] ", typeSelectedObj[type], type);

    dispatch(selectOwnershipType(typeSelectedObj));
  };

  const toggleDropdown = (dropdown) => {
    console.log("toggleDropdown ", dropdown);
    setShowFilters({
      ...showFilters,
      // status: false,
      size: false,
      // deliveryNumber: false,
      // type: false,
      // propertyType: false,
      villages: false,
      land_type: false,
      ownership: false,
      [dropdown]: !showFilters[dropdown],
    });
  };

  const dropdownRefs = useRef([]);

  const handleCloseDropdown = (dropdown, index) => {
    return (e) => {
      if (dropdownRefs.current[index].contains(e.relatedTarget)) {
        return;
      }

      setShowFilters({
        ...showFilters,
        [dropdown]: false,
      });
    };
  };

  return (
    <div className="topbar-container">
      <div className="topbar-sub-container topbar-sub-container-left">
        {/* <Box className="box-container box-search">
          <Icon
            title="Search"
            baseClassName="fas"
            className="fa-regular fa-magnifying-glass container-icon"
            fontSize="small"
          />
          <TextField
            id="input-with-sx"
            placeholder={
              user.language !== "hi"
                ? "Site ID"
                : "साइट आईडी से खोजें"
            }
            variant="standard"
            onChange={handleChange}
          />
        </Box> */}

        <div
          className="filters-dropdown-container-box"
          onBlur={handleCloseDropdown("villages", 0)}
          ref={(el) => (dropdownRefs.current[0] = el)} // Set a ref to the fourth dropdown
          tabIndex={11}
        >
          <Button
            onClick={() =>
              // hide other dropdowns
              toggleDropdown("villages")
            }
            variant="contained"
            style={{
              borderRadius: "0.75rem",
              background: "var(--bg-color)",
              color: "var(--text-color)",
              padding: "1rem",
              width: "12rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            className="filters-button"
          >
            <FilterListIcon
              titleAccess="Filter"
              className="container-icon"
              fontSize="small"
            />

            <p className="filters-button-p">
              <Translate text="Select Village" />
            </p>

            <KeyboardArrowDownIcon titleAccess="Expand" fontSize="small" />
          </Button>

          {showFilters.villages && (
            // <div className="status-select-dropdown">
            //   {villageList.data.map((village) => {
            //     return (
            //       <div
            //         key={"village-" + village}
            //         className="site-info-status-select-sub-container cursor-pointer"
            //         onClick={() => {
            //           updateSelectedVillage(village);
            //         }}
            //       >
            //         <Checkbox
            //           onChange={() => updateSelectedVillage(village)}
            //           checked={selectedVillage === village}
            //         />

            //         <p
            //           className="m-0"
            //           style={{ flexGrow: 1, fontSize: "0.8rem" }}
            //         >
            //           <Translate text={village} />
            //         </p>
            //       </div>
            //     );
            //   })}
            // </div>
            <div className="status-select-dropdown">
              {/* 0th Item: Search Input */}
              <div
                key="search-box"
                className="site-info-status-select-sub-container"
                style={{ padding: "0.5rem" }}
              >
                <input
                  type="text"
                  placeholder="Search village..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "0.4rem",
                    fontSize: "0.8rem",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                />
              </div>

              {/* Filtered Dropdown Items */}
              {filteredVillages.map((village) => (
                <div
                  key={"village-" + village}
                  className="site-info-status-select-sub-container cursor-pointer"
                  onClick={() => updateSelectedVillage(village)}
                >
                  <Checkbox
                    onChange={() => updateSelectedVillage(village)}
                    checked={selectedVillage === village}
                  />

                  <p
                    className="m-0"
                    style={{ flexGrow: 1, fontSize: "0.8rem" }}
                  >
                    <Translate text={village} />
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>

        <div
          className="filters-dropdown-container-box"
          onBlur={handleCloseDropdown("land_type", 1)}
          ref={(el) => (dropdownRefs.current[1] = el)} // Set a ref to the third dropdown
          tabIndex={12}
        >
          <Button
            onClick={() =>
              // hide other dropdowns
              toggleDropdown("land_type")
            }
            variant="contained"
            style={{
              borderRadius: "0.75rem",
              background: "var(--bg-color)",
              color: "var(--text-color)",
              padding: "1rem",
              width: "12rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            className="filters-button"
          >
            <FilterListIcon
              titleAccess="Filter"
              className="container-icon"
              fontSize="small"
            />

            <p className="filters-button-p">
              <Translate text="land_type" />
            </p>

            <KeyboardArrowDownIcon titleAccess="Expand" fontSize="small" />
          </Button>

          {showFilters.land_type && (
            <div className="status-select-dropdown">
              {landType.map((type) => {
                return (
                  <div
                    key={"type-" + type}
                    className="site-info-status-select-sub-container cursor-pointer"
                    onClick={() => {
                      handleLandTypeCheckboxClick(selectedLandType[type], type);
                    }}
                  >
                    <Checkbox
                      onChange={() =>
                        handleLandTypeCheckboxClick(
                          selectedLandType[type],
                          type
                        )
                      }
                      checked={selectedLandType[type] === true}
                    />

                    <p
                      className="m-0"
                      style={{ flexGrow: 1, fontSize: "0.8rem" }}
                    >
                      <Translate text={type} />
                    </p>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div
          className="filters-dropdown-container-box"
          onBlur={handleCloseDropdown("ownership", 2)}
          ref={(el) => (dropdownRefs.current[2] = el)} // Set a ref to the third dropdown
          tabIndex={13}
        >
          <Button
            onClick={() =>
              // hide other dropdowns
              toggleDropdown("ownership")
            }
            variant="contained"
            style={{
              borderRadius: "0.75rem",
              background: "var(--bg-color)",
              color: "var(--text-color)",
              padding: "1rem",
              width: "12rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            className="filters-button"
          >
            <FilterListIcon
              titleAccess="Filter"
              className="container-icon"
              fontSize="small"
            />

            <p className="filters-button-p">
              <Translate text="ownership" />
            </p>

            <KeyboardArrowDownIcon titleAccess="Expand" fontSize="small" />
          </Button>

          {showFilters.ownership && (
            <div className="status-select-dropdown">
              {ownershipType.map((owner) => {
                return (
                  <div
                    key={"owner-" + owner}
                    className="site-info-status-select-sub-container cursor-pointer"
                    onClick={() => {
                      handleOwnershipCheckboxClick(
                        selectedOwnership[owner],
                        owner
                      );
                    }}
                  >
                    <Checkbox
                      onChange={() =>
                        handleOwnershipCheckboxClick(
                          selectedOwnership[owner],
                          owner
                        )
                      }
                      checked={selectedOwnership[owner] === true}
                    />

                    <p
                      className="m-0"
                      style={{ flexGrow: 1, fontSize: "0.8rem" }}
                    >
                      <Translate text={owner} />
                    </p>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div
          className="filters-dropdown-container-box"
          onBlur={handleCloseDropdown("size", 3)}
          ref={(el) => (dropdownRefs.current[3] = el)}
          tabIndex={14}
          style={{ position: "relative" }} // Ensure the parent div has relative positioning
        >
          <Button
            onClick={() => {
              toggleDropdown("size");
              toggleBox();
            }}
            variant="contained"
            style={{
              borderRadius: "0.75rem",
              background: "var(--bg-color)",
              color: "var(--text-color)",
              padding: "1rem",
              width: "12rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            className="filters-button"
          >
            <FilterListIcon
              titleAccess="Filter"
              className="container-icon"
              fontSize="small"
            />
            <p className="filters-button-p" style={{ textTransform: "none" }}>
              <Translate text="SIZE(sqmtr)" />
            </p>
            <KeyboardArrowDownIcon titleAccess="Expand" fontSize="small" />
          </Button>

          {showInputs && (
            <Box
              sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                zIndex: 10,
                mt: 1,
                p: 2,
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                minWidth: "10rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  justifyContent: "space-between",
                  //width: "100%",
                }}
              >
                <TextField
                  label="Min Size"
                  type="number"
                  variant="outlined"
                  value={minValue}
                  onChange={(e) => setMinValue(e.target.value)}
                  sx={{ flex: 1 }} // Responsive width
                />
                <TextField
                  label="Max Size"
                  type="number"
                  variant="outlined"
                  value={maxValue}
                  onChange={(e) => setMaxValue(e.target.value)}
                  sx={{ flex: 1 }} // Responsive width
                />
              </Box>

              {error && (
                <FormHelperText sx={{ color: "red", mb: 2 }}>
                  {error}
                </FormHelperText>
              )}
              <Box
                mt={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  gap: 2,
                }}
              >
                {/* Submit Button */}
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "grey",
                    color: "white",
                    "&:hover": { backgroundColor: "black" },
                    height: "1.5rem",
                    width: "5rem", // Reduced width
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>

                {/* Toggle Button */}
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: isToggled ? "blue" : "grey",
                    color: "white",
                    "&:hover": {
                      backgroundColor: isToggled ? "darkblue" : "black",
                    },
                    height: "1.5rem",
                    width: "3rem", // Reduced width
                  }}
                  onClick={handleToggle}
                >
                  {/* {isToggled ? "ON" : "OFF"} */}
                  {"RESET"}
                </Button>
              </Box>
            </Box>
          )}
        </div>
      </div>
    </div>
  );
}

export default MapTopbar;
